import { render, staticRenderFns } from "./ReviewTopics.vue?vue&type=template&id=77e0c8c2&scoped=true"
import script from "./ReviewTopics.vue?vue&type=script&lang=js"
export * from "./ReviewTopics.vue?vue&type=script&lang=js"
import style0 from "./ReviewTopics.vue?vue&type=style&index=0&id=77e0c8c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e0c8c2",
  null
  
)

export default component.exports